export default [
  {
    path: '/company/:alias/setting/custom_roles',
    component: () => import('./pages/custom-roles.layout.vue'),
    children: [
      {
        path: '',
        component: () => import('./pages/company/page-company-custom-roles.vue'),
        name: 'company-custom-roles'
      },
      {
        path: 'create',
        component: () => import('./pages/company/page-company-custom-roles-create.vue'),
        name: 'company-custom-roles-create'
      },
      {
        path: 'edit',
        component: () => import('./pages/company/page-company-custom-roles-edit.vue'),
        name: 'company-custom-roles-edit'
      }
    ]
  },
  {
    path: '/admin/instance/custom_roles',
    component: () => import('./pages/custom-roles.layout.vue'),
    children: [
      {
        path: '',
        component: () => import('./pages/admin/page-admin-custom-roles.vue'),
        name: 'admin-custom-roles'
      },
      {
        path: 'create',
        component: () => import('./pages/admin/page-admin-custom-roles-create.vue'),
        name: 'admin-custom-roles-create'
      },
      {
        path: 'edit',
        component: () => import('./pages/admin/page-admin-custom-roles-edit.vue'),
        name: 'admin-custom-roles-edit'
      }
    ]
  }
];
